export const DEFAULT_LEVEL_GENERATION_OPTIONS = {
    mysteryChance: 0.3,
    mysterySliceChance: 0.3,
    tunnelChance: 0.12,
    connectorChance: 0.3,
    arrowChance: 0.15,
    lockPanelChance: 0.5,
    gateChance: 0.5,
    visibleSliceCount: 4,
    holesPerSlice: 3,
};
